// 0_global/media_size.js
// Responsive breakpoint state, exposed on window.NAT.media so any .js file (or an
// inline admin snippet) can read it: e.g.  if (window.NAT.media.isMobile) { … }
//
// These are GETTERS: each read returns the CURRENT viewport state, so the values
// are always fresh on resize — no event wiring or stale snapshots to manage.
// (The old `resizeX` listener is no longer needed; reading re-evaluates live.)

window.NAT = window.NAT || {};

const mediaSizes = {
	desktop: 1280,
	smallTabletMax: 1023,
	tablet: 768,
};

window.NAT.media = {
	// Raw breakpoints, in case a caller wants the numbers.
	sizes: mediaSizes,

	get isMobile() {
		return window.innerWidth < mediaSizes.tablet;
	},
	get isTablet() {
		return window.innerWidth >= mediaSizes.tablet && window.innerWidth < mediaSizes.desktop;
	},
	get isDesktop() {
		return window.innerWidth >= mediaSizes.desktop;
	},
	get isSmallTablet() {
		return window.innerWidth <= mediaSizes.smallTabletMax;
	},
};
